import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import * as Icon from 'react-feather';
import { updateEmailSettings } from '../../../../services/emailService';
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import CustomLoader from '../../../common/Loader';
import { Modal } from 'react-bootstrap';
import { logActivity } from '../../../../services/utilService';
import Button from '@material-ui/core/Button';

class AddEmailTemplate extends Component {
    state = {
        Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
        loading: false,
        openAddTemplateDialog: this.props.openAddTemplateDialog ? this.props.openAddTemplateDialog : false,
    };

    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
    }

    async componentDidMount() {
        //console.log('state', this.state);
        //Get
    }

    handleClose(event) {
        this.setState({ openAddTemplateDialog: false })
        if (event && (event.target.innerText).toLowerCase() === 'add') {
            this.addNewTemplate();
        }
    }

    async addNewTemplate() {
        const { data } = await updateEmailSettings(this.state.Project_ID, this.state.email);
        if (data.includes('Error')) {
            toaster('error', data);
            logActivity('/projectSettings', 'PROJECT_EMAIL_TEMPLATE_CREATE_FAILED');
        } else {
            toaster('success', data);
            logActivity('/projectSettings', 'PROJECT_EMAIL_TEMPLATE_CREATE_SUCCESS');
            this.setState({ open: false });
        }
    }

    render() {
        if (this.state.loading) {
            return <CustomLoader loading={this.state.loading} />;
        }

        let email = {}

        return (
            <React.Fragment>
                <Modal size='xl' key={this.state.openAddTemplateDialog} show={this.state.openAddTemplateDialog} onHide={this.handleClose} scrollable={true}>
                    <Modal.Header closeButton>Add Email Template</Modal.Header>
                    <Modal.Body className='container'>
                        <div>
                            <div className='form-group'>
                                <label htmlFor='templateName'>Template Name</label>
                                <input className='form-control' id='templateName' name='templateName' value={email.TemplateName} onChange={(e) => this.handleTemplateChange('templateName', e.target.value)} />
                            </div>
                            <div className='form-group'>
                                <label htmlFor='emailFrom'>Sender</label>
                                <input className='form-control' id='emailFrom' name='emailFrom' value={email.emailFrom} onChange={(e) => this.handleTemplateChange('emailFrom', e.target.value)} />
                            </div>
                            <div className='form-group'>
                                <label htmlFor='emailTo'>Email Recipients</label>
                                {/* Add a dropdown for list values */}
                                <input className='form-control' id='emailTo' name='emailTo' value={email.emailTo} onChange={(e) => this.handleTemplateChange('emailTo', e.target.value)} />
                            </div>
                            <div className='form-group'>
                                <label htmlFor='emailSubject'>Email Subject</label>
                                <input className='form-control' id='emailSubject' name='emailSubject' value={email.emailSubject} onChange={(e) => this.handleTemplateChange('emailSubject', e.target.value)} />
                            </div>
                            <div className='form-group'>
                                <label htmlFor='emailBody'>Email Body</label>
                                <textarea name='emailBody' id='emailBody' className='form-control' rows={15} onChange={(e) => this.handleTemplateChange(e.target.value)} placeholder='' value={email.emailBody} />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleClose}>Cancel</Button>
                        <Button onClick={this.handleClose}>Add</Button>
                    </Modal.Footer>
                </Modal>
                <ToastContainer />
            </React.Fragment>
        );
    }

}

export default AddEmailTemplate;
